import { Trophy, Medal, Award, Minus } from "lucide-react";

const RANK_CONFIG = {
  PLATINUM: { label: "Platinum", icon: Trophy, className: "bg-gradient-to-br from-slate-200 to-slate-400 text-slate-900 border-slate-400" },
  GOLD: { label: "Gold", icon: Medal, className: "bg-gradient-to-br from-amber-300 to-amber-500 text-amber-950 border-amber-500" },
  SILVER: { label: "Silver", icon: Award, className: "bg-gradient-to-br from-zinc-300 to-zinc-400 text-zinc-900 border-zinc-400" },
  NON_CLASSE: { label: "Non classé", icon: Minus, className: "bg-slate-100 text-slate-500 border-slate-300 dark:bg-slate-800 dark:text-slate-400" },
};

export function RankBadge({ rank, worldClassPct, testId = "rank-badge" }) {
  const cfg = RANK_CONFIG[rank] || RANK_CONFIG.NON_CLASSE;
  const Icon = cfg.icon;
  return (
    <div
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border-2 font-bold text-xs uppercase tracking-wide shadow-sm ${cfg.className}`}
      title={`World Class Score: ${worldClassPct}%`}
    >
      <Icon className="h-3.5 w-3.5" />
      {cfg.label}
      {typeof worldClassPct === "number" && <span className="font-mono font-normal opacity-80">· {worldClassPct}%</span>}
    </div>
  );
}
